import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=0bf247af&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=0bf247af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf247af",
  null
  
)

export default component.exports